import React, { FC } from 'react';

import { Stack, Typography } from '@mui/material';

interface SettingsPageHeaderProps {
  /**
   * An optional icon or image rendered beside the title.
   */
  icon?: React.ReactNode;
  /**
   * The page title.
   */
  title: React.ReactNode;
  /**
   * An optional description rendered below the title.
   */
  description?: React.ReactNode;
  /**
   * Optional action(s) aligned to the far right of the title row (e.g. a primary create button).
   */
  headerAction?: React.ReactNode;
}

/**
 * Standard settings page header rendering an optional icon/image, a title, an optional description,
 * and optional right-aligned header actions.
 */
export const SettingsPageHeader: FC<SettingsPageHeaderProps> = ({ icon, title, description, headerAction }) => (
  <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
    <Stack gap={1.5} flex={1} minWidth={0}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon}
        {title && (
          <Typography color="text.primary" variant="h3">
            {title}
          </Typography>
        )}
      </Stack>
      {description && (
        <Typography pt={1} color="text.secondary">
          {description}
        </Typography>
      )}
    </Stack>
    {headerAction ? (
      <Stack direction="row" alignItems="center" flexShrink={0} spacing={1}>
        {headerAction}
      </Stack>
    ) : null}
  </Stack>
);
